/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { Button, Form, message, Modal } from "antd";
import copy from "copy-to-clipboard";
import React, { useCallback } from "react";
import { useFormatMessage } from "src/hooks";
import messageIds from "src/locales/messageIds";

export default React.memo(
  (props: { isView: boolean; content: string; onCancel: () => void }) => {
    const { isView, content, onCancel } = props;
    const formatMessage = useFormatMessage();
    const [form] = Form.useForm();

    const onCopy = useCallback(
      (content: string) => {
        copy(content);
        message.success(formatMessage(messageIds.common.copySuccessfully));
      },
      [formatMessage]
    );

    return (
      <div>
        <Modal
          title={formatMessage(messageIds.license.common.issueSuccessfully)}
          visible={isView}
          footer={""}
          onCancel={onCancel}
          css={css`
            width: 700px !important;
            .ant-modal-header {
              border-bottom: none;
            }
          `}
        >
          <Form layout="vertical" form={form}>
            <Form.Item label={formatMessage(messageIds.license.common.name)}>
              <div
                css={css`
                  display: flex;
                  align-items: center;
                  color: rgba(0, 0, 0, 0.85);
                  background-color: rgb(247, 249, 252);
                  padding: 5px 13px;
                  min-height: 35px;
                  max-width: 650px;
                  word-wrap: break-word;
                  word-break: break-all;
                `}
              >
                {content}
              </div>
            </Form.Item>
            <div
              css={css`
                text-align: right;
              `}
            >
              <Button
                type="primary"
                css={css`
                  height: 32px;
                  min-width: 88px;
                  border-radius: 4px;
                  margin-right: 10px;
                `}
                onClick={() => onCopy(content)}
              >
                {formatMessage(messageIds.license.common.copyLicense)}
              </Button>
              <Button
                type="primary"
                css={css`
                  height: 32px;
                  min-width: 88px;
                  border-radius: 4px;
                `}
                onClick={onCancel}
              >
                {formatMessage(messageIds.common.confirm)}
              </Button>
            </div>
          </Form>
        </Modal>
      </div>
    );
  }
);
